export const MESSAGING_CHANNEL_TYPE = 'messaging'

export const CONVERSATIONS_PAGE_SIZE = 30

export const REQUEST_TIMEOUT_MS = 15_000

export const REFRESH_EVENT_TYPES = [
  'message.new',
  'message.read',
  'message.delivered',
  'notification.message_new',
  'notification.mark_read',
  'channel.updated',
] as const

export const CUSTOM_MESSAGE_TYPE = {
  date: 'date',
  intro: 'intro',
} as const
